export const UMB_TEMPORARY_FILE_REPOSITORY_ALIAS = 'Umb.Repository.TemporaryFile.Config';
export const UMB_TEMPORARY_FILE_CONFIG_STORE_ALIAS = 'UmbTemporaryFileConfigStore';
